import { createStore, applyMiddleware} from 'redux';
import createSagaMiddleware from 'redux-saga'

import reducers from 'reducer';
import sagas from 'saga'

const sagaMiddleware = createSagaMiddleware()

const storeConfigure = () => {

	var store = createStore(reducers,applyMiddleware(sagaMiddleware))

	console.log("REACT_APP : ", process.env.REACT_APP_ENV)
	
	// if(process.env.REACT_APP_ENV==="DEV"){
	// 	store = createStore(
	// 		reducers
	// 		,compose(applyMiddleware(sagaMiddleware)
	// 		, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
	// 		)
	// }

	sagaMiddleware.run(sagas)

	return store
}

export default storeConfigure